export const ADMIN_ROLES = ["admin", "super_admin", "saas_admin", "principal", "coordinator"];

export const isAdmin = (role) => ADMIN_ROLES.includes(role);